import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {history} from "../../history/History";
import UploadImage from "../shared/UploadImage";
import KeyVal from "../shared/KeyVal";
import Loading from "../shared/Loading";
import {error, show} from "../../utils/Toast";
import {taskDoneByTutor, uploadFilePrivateAnswer} from "../../utils/API";

class SendAnswer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            files: [],
            filesAddress: [],
            sendAnswerApi: false
        }
    }

    componentDidMount() {
        if (!this.props.currentTask) {
            history.push("/hom")
        }
    }

    sendAnswer = () => {
        this.setState({
            sendAnswerApi: true
        })
        show("Please wait, Sending files")
        this.sendFile(this.props.currentTask.hashId, 0)
    }

    sendFile = (taskHashId, index) => {
        if (index >= this.state.files.length) {
            if (this.state.filesAddress.length === 0) {
                error("There was an error sending some files")
                return
            }
            taskDoneByTutor(taskHashId, this.state.filesAddress.join('||'), () => {
                history.goBack();
                show("Solution is submitted, please wait for the student to confirm")
            }, () => {
                this.setState({
                    sendAnswerApi: false
                })
            })
            return;
        }
        uploadFilePrivateAnswer(taskHashId, this.state.files[index], (res) => {
            if (!res.data.success) {
                error("There was an error sending some files")
                this.setState({
                    sendAnswerApi: false
                })
                return
            }
            this.setState({filesAddress: this.state.filesAddress.concat(res.data.data)})
            this.sendFile(taskHashId, index + 1);
        }, () => {
            error("There was an error sending some files")
            this.setState({
                sendAnswerApi: false
            })

        })
    }

    render() {
        return (
            <div className="contain-app">
                <button className="back-btn" onClick={() => history.goBack()}>
                    <i className="icon-arrow_back_ios"/>
                </button>
                <div className="title-login pt-3 bold">
                    <h4>Send Solution</h4>
                </div>

                <div className="mt-3 mb-3 text-center">
                    <h5>Please send solution files</h5>
                </div>
                <div className="body-login">
                    <div>
                        {this.props.currentTask && <div className="pb-3 mb-3 border-bottom-dashed">
                            <KeyVal name="Student:" value={this.props.currentTask.student.username}/>
                            <KeyVal name="Field:" value={this.props.currentTask.field.name}/>
                            <KeyVal name="Category:" value={this.props.currentTask.category.name}/>
                            <KeyVal name="Due:"
                                    value={new Date(this.props.currentTask.deadline).toLocaleDateString("en-US")}/>
                        </div>}
                        <div>
                            <span className="green-text">you can send 10 file in max 200MB</span>
                        </div>
                        <UploadImage id="files"
                                     ignoreType
                                     onComplete={(file) => {
                                         this.setState({
                                             files: this.state.files.concat([file])
                                         })
                                     }}
                        >
                            <div className="upload-image-photo">
                                <span>{'Upload files'}</span>
                            </div>
                        </UploadImage>
                        <div>
                            {
                                this.state.files.map((file, i) => <div key={i} className="mb-1">
                                    <span>{file.name}</span>
                                    <button onClick={() => {
                                        let index = this.state.files.indexOf(file);
                                        let newFiles = []
                                        for (let j = 0; j < this.state.files.length; j++) {
                                            if (j !== index)
                                                newFiles.push(this.state.files[j])
                                        }
                                        this.setState({files: newFiles})
                                    }}><i className="icon-trash red-text ml-2 s1-25-x"/></button>
                                </div>)
                            }
                        </div>
                        {this.state.files.length === 0 && <div>
                            <span className="red-text">you must upload at least 1 file</span>
                        </div>}
                        <button
                            className="waves-effect waves-light mt-3 btn-large white w-100 no-uppercase bold"
                            disabled={this.state.sendAnswerApi || this.state.files.length === 0}
                            onClick={this.sendAnswer}>
                            <Loading show={this.state.sendAnswerApi}>
                                <span>Send Solution</span>
                            </Loading>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
        currentTask: state.param[Objects.currentTask],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SendAnswer)
